/** Stripe Checkout Form (ui_mode: elements) — dark theme aligned with FairShare. */
export const FAIRSHARE_CHECKOUT_APPEARANCE = {
    theme: "night",
    variables: {
        colorPrimary: "#00BF0D",
        colorBackground: "#1E1E1E",
        colorText: "#F5F5F5",
        colorTextSecondary: "#A3A3A3",
        colorDanger: "#F87171",
        borderRadius: "8px",
        fontFamily: "Inter, system-ui, sans-serif",
    },
    rules: {
        ".Input": {
            backgroundColor: "#262626",
            border: "1px solid rgba(255, 255, 255, 0.12)",
        },
        ".Label": {
            color: "#D4D4D4",
        },
    },
};
